import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: 'input[onlyNumbers]',
  standalone: true
})
export class OnlyNumbersDirective {
    
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];

    console.log(event);

    if (allowedKeys.includes(event.key)) {
      return; // allow navigation/editing
    }

    // Block non-numeric keys
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }
}